import React from 'react';
import Browser from '@material-ui/icons/WebAssetOutlined';

const BrowserIcon = (props) => <Browser {...props} />;

export default BrowserIcon;
